import React, { Component } from 'react'
import { formatDate } from '../actions/dateUtility';
import UnitStatus from '../enums/UnitStatus'
import UnitStage from '../enums/UnitStage'

export const unitHasDropDate = unit => {
  return unit && unitWithdrawalDate(unit) !== null
}

export const unitDropDatePassed = unit => {
  return unitHasDropDate(unit) && new Date(unitWithdrawalDate(unit)) < new Date()
}

export const unitDropDateNotPassed = unit => {
  return unitHasDropDate(unit) && new Date(unitWithdrawalDate(unit)) >= new Date()
}

export const unitWithdrawalDate = unit => {
  return unit.lastEstudentWdDate !== null ? unit.lastEstudentWdDate : unit.lastWdDate !== null ? unit.lastWdDate : unit.availabilityEndDate
}

export const isPlacementUnit = unit => {
  return unit.unitCategoryTypeCode === 'UPL' || unit.unitCategoryTypeCode === 'PPL'
}

export const showUnitDropDateMessage = unit => {
  return unit.virtual !== true && unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED && isPlacementUnit(unit) && unit.selfWithdrawalFlag
}

export const getDropDateUnitText = unit => {
  if (showUnitDropDateMessage(unit)) {
    if (unitDropDatePassed(unit)) {
      return <p className="unit-drop-date">{`Online withdraw deadline has passed`}</p>
    } else if (unitDropDateNotPassed(unit)) {
      return <p className="unit-drop-date">{`Online withdraw deadline: ${formatDate(formatDateLocale(unitWithdrawalDate(unit)), 'dd MMM yyyy')}`}</p>
    }
  }
}

export const formatDateLocale = dateArr => {
  if (dateArr.length === 3) {
    return `${dateArr[0]}/${dateArr[1]}/${dateArr[2]}`
  }
  return dateArr
}
